import { FontType, SelectedReflowTabType } from '../../drawing/types';
import ReflowableContentUIAction from '../../actions/ui/ReflowableContentUIAction';

export interface ReflowableContentSettingState {
  selected: SelectedReflowTabType;
  fontType: FontType;
  fontSize: number;
  lineHeight: number;
  padding: number;
  sneEnabled: boolean;
  sneUserPatternBackgroundColorIndex: number;
}

export function initReflowableContentSettingUIState(): ReflowableContentSettingState {
  return {
    selected: SelectedReflowTabType.Reflow,
    fontType: FontType.ContentAware,
    fontSize: 100,
    lineHeight: 1,
    padding: 1,
    sneEnabled: false,
    sneUserPatternBackgroundColorIndex: 0,
  };
}

export const reflowableContentSetting = (
  state: ReflowableContentSettingState,
  action: ReflowableContentUIAction.Action,
): ReflowableContentSettingState => {
  switch (action.type) {
    case ReflowableContentUIAction.ActionType.SET_FONT_TYPE: {
      return { ...state, fontType: action.fontType };
    }
    case ReflowableContentUIAction.ActionType.SET_FONT_SIZE: {
      return { ...state, fontSize: action.fontSize };
    }
    case ReflowableContentUIAction.ActionType.SET_LINE_HEIGHT: {
      return { ...state, lineHeight: action.lineHeight };
    }
    case ReflowableContentUIAction.ActionType.SET_PADDING: {
      return { ...state, padding: action.padding };
    }
    case ReflowableContentUIAction.ActionType.SET_SELECTED: {
      return { ...state, selected: action.selected };
    }
    case ReflowableContentUIAction.ActionType.SET_SNE_ENABLE: {
      return { ...state, sneEnabled: action.sneEnabled };
    }
  }
};
